





















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import approximateValue from '@/helpers/approximateValue';
import tableComponent from '@/components/TheTable.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {
  requestReviewTransfer,
  requestReviewTrade
} from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;

@Component({
  name: 'NotificationPage',
  components: {
    titlePageComponent,
    tableComponent,
    SidebarRight,
    PulseLoader
  }
})
export default class NotificationPage extends Base {
  waitingTransfersTable = {
    titleText: 'LIST OF WAITING TRANSFERS',
    titleBg: 'green-blue',
    sorted: 'id',
    columns: [
      { field: 'rowId', title: '#' },
      { field: 'receiver', title: 'RECEIVER' },
      { field: 'sender', title: 'SENDER' },
      { field: 'amount', title: 'AMOUNT OF SHARES' },
      { field: 'date', title: 'DATE' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  waitingTradesTable = {
    titleText: 'LIST OF WAITING TRADES',
    titleBg: 'pink-title',
    sorted: 'id',
    columns: [
      { field: 'rowId', title: '#' },
      { field: 'receiver', title: 'RECEIVER' },
      { field: 'sender', title: 'SENDER' },
      { field: 'amount', title: 'AMOUNT OF SHARES' },
      { field: 'price', title: 'PRICE PER SHARE' },
      { field: 'date', title: 'DATE' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };

  // Computed
  get waitingTransfersTableData() {
    let rows: any[] = [];
    let index = 0;
    for (let transfer of this.getTokenTransfersEscrow) {
      if (transfer.status === 0) {
        index += 1;
        let row: any = {};
        row.rowId = index;
        row.id = transfer.id;
        row.receiver = this.getMember(transfer.to) ? this.getMember(transfer.to).name : null;
        row.sender = this.getMember(transfer.from) ? this.getMember(transfer.from).name : null;
        row.from = transfer.from ? transfer.from : null;
        row.to = transfer.to ? transfer.to : null;
        row.amount = formatData.number(transfer.amount);
        row.date = this.$moment.unix(transfer.createTime).format(FORMAT_DATE);
        row.resultTime = this.$moment.unix(transfer.resultTime).format(FORMAT_DATE);
        rows.push(row);
      }
    }
    Vue.set(this.waitingTransfersTable, 'rows', rows);
    return this.waitingTransfersTable;
  }
  get waitingTradesTableData() {
    let rows: any[] = [];
    let index = 0;
    for (let trade of this.getTradeTransfersEscrow) {
      index += 1;
      if (trade.status === 0) {
        const order = this.getActiveOrders.find(order => order.id === trade.orderId);
        const orderCreator =
          order && this.getMember(order.address) ? this.getMember(order.address).name : null;
        const tradeCreator = this.getMember(trade.from) ? this.getMember(trade.from).name : null;
        let row: any = {};
        row.id = trade.id;
        row.rowId = index;
        row.tradeId = trade.tradeId;
        row.orderId = trade.orderId;
        row.receiver = trade.mode === 1 ? orderCreator : tradeCreator;
        row.sender = trade.mode === 1 ? tradeCreator : orderCreator;
        row.to = trade.mode === 1 ? order.address : trade.from;
        row.from = trade.mode === 1 ? trade.from : order.address;
        row.amount = formatData.number(trade.amount);
        row.date = this.$moment.unix(trade.createTime).format(FORMAT_DATE);
        row.resultTime = this.$moment.unix(trade.resultTime).format(FORMAT_DATE);
        row.status = trade.status;
        row.price =
          order && `ETH ${order.price} / $ ${+(order.price * approximateValue()).toFixed(5)}`;
        rows.push(row);
      }
    }
    Vue.set(this.waitingTradesTable, 'rows', rows);
    return this.waitingTradesTable;
  }
  get escrowTransferPending() {
    return this.getPendings.escrowTransfer.id;
  }
  get escrowTradePending() {
    return this.getPendings.escrowTrade.id;
  }

  // Methods
  reviewTransfer(props) {
    this.setSideBarForm(requestReviewTransfer(props));
    this.openClose();
  }
  reviewTrade(props) {
    this.setSideBarForm(requestReviewTrade(props));
    this.openClose();
  }
  isEscrowTransferPending(props) {
    return this.escrowTransferPending === props.id;
  }
  isEscrowTradePending(props) {
    return this.escrowTradePending === props.id;
  }
};
